import BaseComponent from 'foundation/base-component';
import Cookies from 'js-cookie';
import overlay from '../../../general/js/overlay';
import _ from 'lodash';

const COOKIE_WARNING_AGREED = 'cookie-warning-settings_agreed';
const COOKIE_WARNING_AGREE_BUTTON_CLASS = 'cookie-warning__agree-button';
const COOKIE_WARNING_AGREE_LINK_CLASS = 'cookie-warning__agree-link';
const COOKIE_CONTROL_EXPIRY_DAYS = 'cookieControlExpiryDaysValue';

export default class CookieWarningComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.onCloseCookieWarning = this.onCloseCookieWarning.bind(this);
        this.closeSlideoutCookiePanelHandler = this.closeSlideoutCookiePanelHandler.bind(this);
        this.acceptCookiesHandler = this.acceptCookiesHandler.bind(this);
        this.cookieWarningSettingsAgreedTitle = this.getCookieWarningOption('warningSettingsAgreed', COOKIE_WARNING_AGREED);
        this.requiredCookiesForGoogleAnalytics = this.getCookieWarningOption('requiredCookiesForGoogleAnalytics');
        this.init();
    }

    isSiteVisited() {
        const warningAgreedCookie = Cookies.get(this.cookieWarningSettingsAgreedTitle);
        const acceptedCookies = warningAgreedCookie !== undefined;
        return acceptedCookies;
    }

    init() {
        setTimeout(() => {
            if (!this.isSiteVisited()){
                this.element.classList.add('is-visible');
                overlay.show('overlay');

                const agreeButton = document.getElementsByClassName(COOKIE_WARNING_AGREE_BUTTON_CLASS)[0];
                const agreeLink = document.getElementsByClassName(COOKIE_WARNING_AGREE_LINK_CLASS)[0];
                let cookieExpiryDays = this.getCookieExpiryDays();
                
                this.addListener(agreeButton, 'click', () => {
                    Cookies.set(this.cookieWarningSettingsAgreedTitle, '1', { expires: cookieExpiryDays, secure: true });
                    this.onCloseCookieWarning();
                });
                this.addListener(agreeLink, 'click', () => {
                    this.onCloseCookieWarning();
                });
            }
        }, 100);
    }

    onCloseCookieWarning() {
        setTimeout(() => {
            const { civicukCloseButtonId, civicukAcceptAllButtonId} = this.options;
            var slideoutCloseButton = null;
            var acceptAllButton = null; 

            if (civicukCloseButtonId !== undefined && !_.isEmpty(civicukCloseButtonId)){
                slideoutCloseButton = document.getElementById(civicukCloseButtonId);
            }

            if (civicukAcceptAllButtonId !== undefined && !_.isEmpty(civicukAcceptAllButtonId)){
                acceptAllButton = document.getElementById(civicukAcceptAllButtonId);
            }

            this.addClickEventListener(slideoutCloseButton, this.closeSlideoutCookiePanelHandler);
            this.addClickEventListener(acceptAllButton, this.acceptCookiesHandler);

            this.element.classList.add('is-closed');
            this.element.classList.remove('is-visible');
            overlay.hide('overlay');
        }, 300);
    }

    addClickEventListener(element, callback){
        if(element !== null){
            element.addEventListener('click', callback, { once: true });
        }
    }

    getCookieExpiryDays(){
        var cookieExpiryDays = parseInt(localStorage.getItem(COOKIE_CONTROL_EXPIRY_DAYS));
        if (cookieExpiryDays === null || cookieExpiryDays === undefined)
        {
            cookieExpiryDays = 90;
        }

        return cookieExpiryDays;
    }

    closeSlideoutCookiePanelHandler(){
        let cookieExpiryDays = this.getCookieExpiryDays();
        let cookieControlValue = Cookies.get('CookieControl');
        let cookieControlObj = !_.isEmpty(cookieControlValue) ? JSON.parse(cookieControlValue) : {};
        var cookieWarningAgreedValue = '0';

        if(this.requiredCookiesForGoogleAnalytics && !_.isEmpty(cookieControlObj) && !_.isEmpty(cookieControlObj.optionalCookies)){
            this.requiredCookiesForGoogleAnalytics.forEach(requiredCookie => {
                if( Object.keys(cookieControlObj.optionalCookies).some((optionalCookie) => optionalCookie === requiredCookie )){
                    cookieWarningAgreedValue = '1';
                }
            });
        }

        Cookies.set(this.cookieWarningSettingsAgreedTitle, cookieWarningAgreedValue, { expires: cookieExpiryDays, secure: true });
    }

    acceptCookiesHandler() {
        const cookieExpiryDays = this.getCookieExpiryDays();

        Cookies.set(this.cookieWarningSettingsAgreedTitle, '1', { expires: cookieExpiryDays, secure: true });
    }

    getCookieWarningOption(optionName, defaultValue = undefined){
        return this.options ? this.options[optionName] : defaultValue;
    }
}
